// 全局公共变量  刷新不清除
const configAuthMessage = {
    updata: function(val) {
        // console.log(this)
        this.configAuth = Object.assign(this.configAuth, val)
    },
    getStore() {

    },
    setStore() {

    },
    configAuth: {
        // 隐藏信息 默认不隐藏
        bothBottom: false, //底部信息
        erweima: false, //隐藏 首页二维码？
        customer: false, //隐藏 首页客服？


        // 文案特殊处理 默认为空
        shopCar: "", // 购物车 - 福粒自营
        bottomInfo: "" // 底部备案展示信息公司
    }
}

export default configAuthMessage



// WEBPACK FOOTER //
// ./src/config/configAuthMessage.js